export const OUTLETS_FETCH_ALL = 'OUTLETS_FETCH_ALL';
export const OUTLETS_FETCH_ALL_SUCCESS = 'OUTLETS_FETCH_ALL_SUCCESS';
export const OUTLETS_FETCH_ALL_FAIL = 'OUTLETS_FETCH_ALL_FAIL';
export const OUTLETS_ADD = 'OUTLETS_ADD';
export const OUTLETS_ADD_SUCCESS = 'OUTLETS_ADD_SUCCESS';
export const OUTLETS_ADD_FAIL = 'OUTLETS_ADD_FAIL';
export const OUTLETS_UPDATE = 'OUTLETS_UPDATE';
export const OUTLETS_UPDATE_SUCCESS = 'OUTLETS_UPDATE_SUCCESS';
export const OUTLETS_UPDATE_FAIL = 'OUTLETS_UPDATE_FAIL';
export const OUTLETS_DELETE = 'OUTLETS_DELETE';
export const OUTLETS_DELETE_SUCCESS = 'OUTLETS_DELETE_SUCCESS';
export const OUTLETS_DELETE_FAIL = 'OUTLETS_DELETE_FAIL';
export const OUTLETS_SET_FILTER = 'OUTLETS_SET_FILTER';
